import React from "react";
import "./NewCustomerBack.css";
import { withRouter } from "react-router";

import VettingLeftArrow from "../Svg/VettingLeftArrow";

const NewCustomerBack = ({ title, backUrl, history }) => {
  const gotoUrl = () => {
    history.push(backUrl);
  };

  return (
    <div className="new-customer-back-button__wrapper">
      <div
        onClick={gotoUrl}
        className="new-customer-back-button__arrow"
        style={{ cursor: "pointer", display: "inline" }}
      >
        <VettingLeftArrow />
      </div>
      <span className="new-customer-back-button__title-web" onClick={gotoUrl}>
        {title}
      </span>
      <span
        className="new-customer-back-button__title-mobile"
        onClick={gotoUrl}
      >
        Back
      </span>
    </div>
  );
};

export default withRouter(NewCustomerBack);
